// extracted by mini-css-extract-plugin
export default {"voltName":"voltName___TbKNb","commit":"commit___xM8qW","icon":"icon___v07Wt","history":"history___SMttv"};